import { createFileRoute } from "@tanstack/react-router"
import CollectionTasksTab from "~/components/collections/tabs/CollectionTasksTab"
import { OverviewPage } from "~/components/design-system/pages"
import { useCollectionContext } from "~/context/CollectionProvider"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/demand-planning/noos/_layout/tasks")({
  component: RouteComponent,
})

function RouteComponent() {
  const { collections } = useCollectionContext()
  const collectionIds = collections.map((c) => c.id)
  usePageTracking("NOOS - Tasks")

  return (
    <OverviewPage fillContent>
      <CollectionTasksTab collectionIds={collectionIds} />
    </OverviewPage>
  )
}
